import React from 'react';
import ResultsPerPageDropdown from './ResultsPerPageDropdown';
import clsx from 'clsx';
import { Icon, Icons } from 'components/Icon';

interface PaginatorProps {
  numberOfPages: number;
  page: number;
  hasNext: boolean;
  hasPrevious: boolean;
  numberOfItemsPerPage: number;
  setNumberOfItemsPerPage: (arg: number) => void;
  goToNextPage: any;
  goToPreviousPage: any;
  showPageNumber?: boolean;
}

const Paginator: React.FC<PaginatorProps> = ({
  numberOfPages,
  page,
  hasNext,
  hasPrevious,
  numberOfItemsPerPage,
  setNumberOfItemsPerPage,
  goToNextPage,
  goToPreviousPage,
  showPageNumber = true
}) => {
  return (
    <div className="flex w-full items-center justify-between">
      <div>
        {showPageNumber && (
          <div className="flex items-center">
            <p className="text-[10px] font-medium">Result(s) per page</p>
            <div className="w-[6px]" />
            <div className="w-[45px]">
              <ResultsPerPageDropdown
                selectedOption={{
                  label: numberOfItemsPerPage,
                  value: numberOfItemsPerPage
                }}
                setSelectedOption={option => {
                  setNumberOfItemsPerPage(option.value);
                }}
              />
            </div>
          </div>
        )}
      </div>

      <div className="flex items-center">
        <button
          type="button"
          className={clsx({
            'border-none outline-none flex items-center text-[10px] font-medium':
              true,
            'text-[#C9CED1]': !hasPrevious,
            'text-[#273143]': hasPrevious
          })}
          onClick={() => {
            goToPreviousPage();
          }}
          disabled={!hasPrevious}
        >
          <div className="mr-2">
            <Icon
              name={Icons.ArrowLeft}
              fill={hasPrevious ? '#273143' : '#C9CED1'}
            />
          </div>
          Prev
        </button>
        <>
          <div className="w-[10px]" />

          <span className="flex h-6 w-6 items-center justify-center rounded bg-[#EDF3FF] text-[10px] font-medium">
            {page}
          </span>
          <div className="w-[4px]" />

          <p className="text-[10px] font-medium">of {numberOfPages}</p>
          <div className="w-[10px]" />
        </>
        <button
          type="button"
          className={clsx({
            'border-none outline-none flex items-center text-[10px] font-medium':
              true,
            'text-[#C9CED1]': !hasNext,
            'text-[#273143]': hasNext
          })}
          onClick={() => {
            goToNextPage();
          }}
          disabled={!hasNext}
        >
          Next
          <div className="ml-2">
            <Icon
              name={Icons.ArrowRight}
              fill={hasNext ? '#273143' : '#C9CED1'}
              width={15}
              height={15}
            />
          </div>
        </button>
      </div>
    </div>
  );
};

export default Paginator;
